import API from "./api";

export const signup = (data) => API.post("/auth/signup", data);
export const login = (data) => API.post("/auth/login", data);